import styled from 'styled-components';
import IconRemove from 'assets/icon-close-white.svg';
import IconUploadFile from 'assets/icon-image-add.svg';

export const StoreAppearanceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: flex-start;
  @media (max-width: 890px) {
    flex-direction: column-reverse;
  }
`;

export const StoreAppearanceLeftContent = styled.div`
  flex: 1;
  background-color: #fff;
  border-radius: 10px;
  padding: 30px 30px;
  margin-top: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 1px 10px 10px rgba(108, 49, 151, 0.08),
    10px 10px 20px rgba(108, 49, 151, 0.06),
    30px 30px 30px rgba(108, 49, 151, 0.04);
  @media (max-width: 1024px) {
    padding: 20px 24px;
  }
  @media (max-width: 1000px) {
    width: calc(55% - 10px);
  }
  @media (max-width: 890px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    padding: 17px 15px;
  }
`;

export const StoreAppearanceLeftContentBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StoreAppearanceLeftContentTitle = styled.div`
  font-family: 'Poppins';
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  color: #2f3d48;
  margin-bottom: 30px;
`;

export const StoreAppearanceRightContent = styled.div`
  width: 360px;
  height: 710px;
  background-color: #f2f1f6;
  border-radius: 10px;
  padding: 30px 30px;
  margin-top: 20px;
  position: relative;

  @media (max-width: 1024px) {
    padding: 20px 24px;
  }
  @media (max-width: 767px) {
    padding: 17px 15px;
  }
  &.marketingDisclaimer {
    height: auto;
    font-size: 12px;
    margin-top: 16px;
  }
  .boldItalicText {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-style: italic;
  }
`;

export const StoreAppearanceRightContentTitle = styled.div`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
`;

export const StoreAppearanceRightContentSubtitle = styled.div`
  font-weight: 400;
  margin-top: 20px;
  font-size: 14px;
  line-height: 20px;
`;

export const StoreAppearanceToggleContent = styled.div`
  display: block;
  margin-bottom: 20px;
  &.withBorder {
    padding-top: 25px;
    border: none;
    border-top: 1px solid #f2f1f6;
  }
`;

export const StoreAppearanceToggleTitle = styled.div`
  font-family: 'Poppins';
  font-weight: 500;
  font-size: 14px;
  line-height: 10px;
  letter-spacing: -0.24px;
  padding-bottom: 5px;
  &.marginT25 {
    margin-top: 25px;
  }
  &.marginB20 {
    margin-bottom: 20px;
  }
`;

export const StoreAppearanceInputColorBlock = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  background-color: #f7f7fa;
  padding: 8px 12px;
  border: 1px solid ${(props) => (props['data-error'] ? '#ba0302' : '#d5d8de')};
  border-radius: 6px;
  gap: 8px;
`;

export const ColorLabel = styled.label`
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
`;

export const ColorInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 24px;
  height: 24px;
  opacity: 0;
  cursor: pointer;
`;

export const ColorPreview = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.color};
  border-radius: 4px;
  border: 1px solid #ccc;
`;

export const TextInput = styled.input`
  flex: 1;
  height: 40px;
  border: none;
  background: transparent;
  font-size: 16px;
  outline: none;
`;

export const ErrorMessage = styled.div`
  position: absolute;
  color: #ba0302;
  font-size: 11px;
  line-height: 1;
  font-weight: normal;
  white-space: pre-line;
  max-width: 100%;
  overflow: hidden;
  min-height: 12px;
  margin-top: 3px;
`;

export const StoreAppearanceImageBlock = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 470px) {
    flex-wrap: wrap;
  }
`;

export const StoreAppearanceImage = styled.img`
  margin-right: 10px;
  border-radius: 4px;
  &.logoImg {
    width: 84px;
    height: 84px;
    object-fit: cover;
  }

  &.coverImg {
    width: 300px;
    height: 60px;
    object-fit: cover;
  }
`;

export const StoreAppearanceImageInput = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const StoreAppearanceImageActions = styled.div`
  display: flex;
  align-items: center;
`;

export const StoreAppearanceImageLabel = styled.label`
  position: relative;
  cursor: pointer;
  color: #ff2d38;
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;
  @media (max-width: 470px) {
    flex-wrap: wrap;
  }
  &.logoImg {
    height: 84px;
  }

  &.coverImg {
    min-height: 60px;
  }
`;

export const StoreAppearanceImageUpload = styled.div`
  display: block;
  position: relative;
  background-color: #f7f7fa;

  border-radius: 4px;
  border: 1px dashed #d5d8de;
  width: 300px;
  height: 60px;

  margin-right: 10px;

  &::before {
    position: absolute;
    content: '';
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 49px;
    height: 49px;
    background-image: url(${IconUploadFile});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @media (max-width: 1300px) {
      width: 43px;
      height: 43px;
    }
  }
  &.cover {
    width: 300px;
    height: 60px;
  }
  &.logo {
    width: 84px;
    height: 84px;
  }
`;

export const StoreAppearanceImageLabelText = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 8px;
  color: #929cb9;
  font-weight: 400;
  .redText {
    color: #ff2d38;
    font-weight: bold;
    margin-bottom: 5px;
  }
`;

export const StoreAppearanceCoverImageBlock = styled.div`
  position: relative;
  max-width: 300px;
  max-height: 60px;
  margin-right: 10px;
`;

export const RemovePhotoIcon = styled.div`
  position: absolute;
  margin-left: 9px;
  margin-right: 9px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  background-image: url(${IconRemove});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transition-property: opacity;
  transition-duration: 0.3s;
  right: 0;
  top: 5px;
`;

export const StoreAppearancePhone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  height: 545px;
  margin-top: 20px;
`;

export const StoreAppearancePhoneHeaderBlock = styled.div`
  position: relative;
  height: 63px;
`;

export const StoreAppearancePhoneHeader = styled.img`
  width: 100%;
`;

export const StoreAppearancePhoneUrl = styled.div`
  position: absolute;
  color: #fff;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 6px;
  top: 36px;
  left: 74px;
`;

export const StoreAppearancePhoneContent = styled.div`
  width: 297px;
  margin-top: -4px;
  height: 487px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top: none;
  border-radius: 0 0 18px 18px;
  padding: 0 16px 50px 16px;
`;

export const PhoneContentHeader = styled.div`
  width: calc(100% + 32px);
  margin-left: -16px;
  height: 80px;
  background-image: url(${(props) => props.coverImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
`;

export const PhoneContentHeaderLogo = styled.div`
  position: absolute;
  bottom: 0;
  left: 16px;
  width: 64px;
  height: 64px;
  img {
    width: 64px;
    height: 64px;
    border: 3px solid #fff;
    object-fit: cover;
  }
`;

export const PhoneContentRestaurantName = styled.div`
  font-weight: 700;
  font-size: 19px;
  line-height: 35px;
  word-break: break-word;
`;

export const PhoneContentRestaurantAddress = styled.div`
  font-weight: 400;
  font-size: 9px;
  line-height: 12px;
  word-break: break-word;
  margin-top: 5px;
`;

export const PhoneContentOpeningHours = styled.div`
  margin-top: 5px;
  font-weight: 400;
  font-size: 9px;
  .closedText {
    color: #ff2d38;
  }
  .dotIcon {
    margin: 0 5px;
  }
`;

export const PhoneContentToggle = styled.img`
  width: 87px;
  margin-top: 10px;
  margin-left: -3px;
`;

export const PhoneContentScheduleText = styled.div`
  font-weight: 400;
  font-size: 11px;
  .boldText {
    font-weight: bold;
    margin-left: 5px;
  }
  margin-top: 5px;
`;

export const PhoneContentCategoryText = styled.div`
  margin-top: 15px;
  font-weight: 700;
  font-size: 12px;
`;

export const PhoneContentItemBlock = styled.div`
  padding: 15px 10px 10px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
`;

export const PhoneContentItemImage = styled.img`
  width: 80px;
  height: 80px;
`;

export const PhoneContentItemText = styled.div``;

export const PhoneContentItemName = styled.div`
  font-weight: 700;
  font-size: 10px;
`;

export const PhoneContentItemDescription = styled.div`
  margin-top: 5px;
  font-weight: 400;
  font-size: 9px;
`;

export const PhoneContentItemPrice = styled.div`
  font-weight: 400;
  margin-top: 10px;
  font-size: 9px;
  .outOfStockText {
    color: ${(props) => props.mainColor || '#ff2d38'};
    margin-left: 10px;
  }
`;

export const PhoneContentButtonBlock = styled.div`
  width: 99%;
  margin-top: -40px;
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding: 5px 0;
  position: sticky;
  border: 1px solid #d9d9d9;
  border-top: none;
  border-radius: 0 0 18px 18px;
`;

export const PhoneContentButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 268px;
  height: 39px;
  border-radius: 25px;
  padding: 20px 0;
  background-color: ${(props) => props.mainColor || '#ff2d38'};
  &:hover {
    background-color: ${(props) => props.secondaryColor || '#d40712'};
  }
  span {
    color: #fff;
  }
  cursor: pointer;
`;
